import * as React from "react";
export const AlphabetListItem = (props) => (React.createElement("div", { className: "alphabet-list-item" },
    React.createElement("h5", null, props.term),
    React.createElement("p", null, props.definition)));
